import { ConfigProvider, App as AntApp } from "antd";
import { antdTheme } from "./theme/tokens";
import { AppRouter } from "./config/approuter/approuter";

function App() {
  return (
    <ConfigProvider theme={antdTheme}>
      <AntApp>
        <AppRouter />
      </AntApp>
    </ConfigProvider>
  );
}

export default App;
